import React from 'react';
import classNames from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { ElementType } from '@fiverr-private/bianka_js';
import { reportClick } from '../../../utils/biEvents/events/biankaEvents';

import styles from './styles.module.scss';

export type ChosenTab = 'hire_a_freelancer' | 'browse_services';

export interface TabConfig {
    id: ChosenTab;
    titleKey: string;
    component: React.ReactNode;
}

export const Toggle = ({
    tabsConfig,
    chosenTab,
    setChosenTab,
}: {
    tabsConfig: TabConfig[];
    chosenTab: ChosenTab;
    setChosenTab: (chosenTab: ChosenTab) => void;
}) => {
    const onTabClick = (tabId: ChosenTab) => {
        setChosenTab(tabId);

        reportClick({
            eventName: `clicked_on_${tabId}`,
            elementType: ElementType.TAB,
            elementName: tabId,
        });
    };

    return (
        <Container className={classNames('flex', styles['toggle-container'])}>
            {tabsConfig.map(({ id: tabId, titleKey }) => (
                <Container
                    key={tabId}
                    onClick={() => onTabClick(tabId)}
                    className={classNames(styles.item, 'flex', 'flex-items-center', {
                        [styles.active]: chosenTab === tabId,
                    })}
                >
                    <Typography>
                        <I18n k={titleKey} />
                    </Typography>
                </Container>
            ))}
            <Container
                className={classNames(styles['animation-bar'], {
                    [styles.active]: chosenTab === tabsConfig[0].id,
                    [styles.second]: chosenTab === tabsConfig[1].id,
                })}
            />
        </Container>
    );
};
